import { SecurityMappingModel } from '../model/single-transaction/security-transfer/security-transfer.model'
import { TransactionConstants } from './constants'
import { LOAN_FIELD_COLUMNS } from './loan-field.util'

/**
 * initial data for sec transfer
 *
 * @returns initial data
 */
export function getInitialLoadData(reconDate: string) {
  return [
    {
      id: 'overrideForBasis',
      isValid: false,
      isEditable: false,

      field: 'Override For Basis',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'string',
      default: false,
      isHidden: false,
    },
    {
      id: 'marketValueTransfer',
      isValid: true,
      isEditable: true,
      field: 'Market Value Transfer',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'string',
      default: false,
      isHidden: false,
    },
    {
      id: 'externalMvt',
      isValid: false,
      isEditable: false,
      field: 'External MVT',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'string',
      default: false,
      isHidden: false,
    },
    {
      id: 'externalMvtDate',
      isValid: true,
      isEditable: false,
      field: 'External MVT Date',
      errorMessage: '',
      validityStatus: 'valid',
      type: 'date',
      default: '',
      isHidden: false,
    },
    {
      id: 'externalMvtPrice',
      isValid: false,
      isEditable: false,
      field: 'External MVT Price',
      validityStatus: 'valid',
      type: 'number',
      errorMessage: '',
      default: '',
      isHidden: false,
    },
    {
      id: 'origTradeDate',
      isValid: false,
      isEditable: true,
      field: 'Original Trade Date',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'date',
      default: reconDate,
      isHidden: false,
    },

    {
      id: 'origSettleDate',
      isValid: true,
      isEditable: true,
      field: 'Original Settle Date',

      errorMessage: '',
      validityStatus: 'date',
      type: 'date',
      default: reconDate,
      isHidden: false,
    },
    {
      id: 'origPrice',
      isValid: false,
      isEditable: true,
      field: 'Original Purchase Price',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'origCost',
      isValid: false,
      isEditable: true,
      field: 'Original Cost',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'origCommission',
      isValid: false,
      isEditable: true,
      field: 'Original Commission',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'accumulatedOtti',
      isValid: false,
      isEditable: true,
      field: 'Accummulated OTTI',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'proceeds',
      isValid: false,
      isEditable: true,
      field: 'Proceeds',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'yield',
      isValid: false,
      isEditable: true,
      field: 'Yield',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'accruedInterest',
      isValid: false,
      isEditable: true,
      field: 'Accrued Interest',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'factor',
      isValid: false,
      isEditable: true,
      field: 'Factor',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'daysImpaired',
      isValid: false,
      isEditable: true,
      field: 'Days Impaired',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'accruedAtLoad',
      isValid: false,
      isEditable: true,
      field: 'Accrued At Load',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'amortStartCost',
      isValid: false,
      isEditable: true,
      field: 'Amort Start Cost',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'amortStartDate',
      isValid: false,
      isEditable: true,
      field: 'Amort Start Date',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'date',
      default: reconDate,
      isHidden: false,
    },
    {
      id: 'amortStartPrice',
      isValid: false,
      isEditable: true,
      field: 'Amort Start Price',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'amortOverride',
      isValid: false,
      isEditable: true,
      field: 'Amort Override',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'string',
      default: '',
      isHidden: false,
    },
    {
      id: 'taxDaysWashSale',
      isValid: false,
      isEditable: true,
      field: 'Tax days held	Wash sale',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'washSaleDeferredLoss',
      isValid: false,
      isEditable: true,
      field: 'Wash Sale Deferred Loss',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'accruedMarketDiscount',
      isValid: false,
      isEditable: true,
      field: 'Accrued Market Discount',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxOriginalPurchaseRate',
      isValid: false,
      isEditable: true,
      field: 'FX Original Purchase Rate',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxOriginalCost',
      isValid: false,
      isEditable: true,
      field: 'FX Original Cost',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxAccumulatedOtti',
      isValid: false,
      isEditable: true,
      field: 'FX Accumulated OTTI',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxBookValueAtLoad',
      isValid: false,
      isEditable: true,
      field: 'FX Book Value At Load',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxAccruedAtLoad',
      isValid: false,
      isEditable: true,
      field: 'FX Accrued At Load',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxAccruedMarketDiscount',
      isValid: false,
      isEditable: true,
      field: 'FX Accrued Market Discount',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxWashSaleDeferredLoss',
      isValid: false,
      isEditable: true,
      field: 'FX Wash sale deferred loss',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'originalOriginationFee',
      isValid: false,
      isEditable: true,
      field: 'Loan Original Origination Fee',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'prepaidInterest',
      isValid: false,
      isEditable: true,
      field: 'Loan Prepaid Interest',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'interestDue',
      isValid: false,
      isEditable: true,
      field: 'Loan Past Due Interest',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    ...LOAN_FIELD_COLUMNS.map(({ field, headerName }) => ({
      id: field,
      isValid: false,
      isEditable: true,
      field: headerName,
      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    })),
    {
      id: 'straddleDeferredLoss',
      isValid: false,
      isEditable: true,
      field: 'Straddle Deferred Loss',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxStraddleDeferredLoss',
      isValid: false,
      isEditable: true,
      field: 'Fx Straddle Deferred Loss',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'section1256DeferredLoss',
      isValid: false,
      isEditable: true,
      field: 'Section 1256 Deferred Loss',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'fxSection1256DeferredLoss',
      isValid: false,
      isEditable: true,
      field: 'Fx Section 1256 Deferred Loss',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'lpCumulativeEarnings',
      isValid: false,
      isEditable: true,
      field: 'LP Cumulative Earnings',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'lpCumulativeDistributions',
      isValid: false,
      isEditable: true,
      field: 'LP Cumulative Distributions',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'returnOfInvestment',
      isValid: false,
      isEditable: true,
      field: 'Return of Investment',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
    {
      id: 'returnOnInvestment',
      isValid: false,
      isEditable: true,
      field: 'Return on Investment',

      errorMessage: '',
      validityStatus: 'valid',
      type: 'number',
      default: '',
      isHidden: false,
    },
  ]
}

/**
 * get generic data
 */
export function getGenericData(reconDate: string): SecurityMappingModel[] {
  return [
    {
      id: 'account',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'Account',
      value: '',
      errorMessage: '',
      isVisible: true,
    },
    {
      id: 'tranType',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Transfer Type',
      value: TransactionConstants.TRANSFER_OPTIONS[0].tranType,
      errorMessage: '',
      isVisible: true,
    },
    {
      id: 'inventoryType',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Inventory Type',
      value: 'LONG',
      errorMessage: '',
      isVisible: true,
    },

    {
      id: 'cusip',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Asset ID',
      value: '',
      errorMessage: '',
      isVisible: true,
    },

    {
      id: 'cwanIdentifier',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'Asset Identifier',
      value: '',
      errorMessage: '',
      isVisible: true,
    },

    {
      id: 'entryDate',
      validityStatus: 'valid',
      type: 'date',
      isEditable: true,
      field: 'Transfer Entry Date',
      value: reconDate,
      errorMessage: '',
      isVisible: true,
    },

    {
      id: 'transferPrice',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'Transfer Price',
      value: '0.0',
      errorMessage: '',
      isVisible: true,
    },

    {
      id: 'units',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'Units',
      value: '0.0',
      errorMessage: '',
      isVisible: true,
    },
    {
      id: 'sourceAccountId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'Source Account Id',
      value: '',
      errorMessage: '',
      isVisible: true,
    },
    {
      id: 'exchangeType',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'Exchange Type',
      value: '',
      errorMessage: '',
      isVisible: true,
    },
  ]
}

/**
 * extra non visible fields
 */
export function getInitialLoadExtraData(): SecurityMappingModel[] {
  return [
    {
      id: 'clientLotId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Client Lot Id',
      value: '',
      errorMessage: '',
      isVisible: false,
    },
  ]
}

/**
 * extra Collateral fields
 */
export function getCollateralBroker(
  collateralValue?: string,
): SecurityMappingModel[] {
  return [
    {
      id: 'collateralBroker',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Collateral Broker',
      value: collateralValue ?? '',
      errorMessage: '',
      isVisible: true,
    },
  ]
}
